import { Organization } from './organization.model';

export enum EmploymentStatus {
    INTERN = 'Stagiaire',
    PROJECT_WORKER = 'Chargé.e de mission',
    PROJECT_LEADER = 'Chef.fe de projet',
    ACTIVITY_LEADER = "Responsable d'activité",
    DIRECTOR = 'Directeur.ice',
}

export interface User {
    id: string;
    mail: string;
    firstname: string;
    lastname: string;
    password?: string;
    isAdmin: boolean;
    isActive?: boolean;
    createdAt?: Date;
    updatedAt?: Date;
    lastConnexionAt?: Date;
    avatarPath?: string;
    organization?: Partial<Organization>;

    employmentStatus: EmploymentStatus;
    departureDate?: Date | null;
    payfitContractId?: string | null;
}

export const userTemplate: User = {
    id: '',
    mail: '',
    firstname: '',
    lastname: '',
    password: '',
    isAdmin: false,
    employmentStatus: EmploymentStatus.PROJECT_WORKER,
};
